//! PLOP_APPEND_TYPES

export const IS_USER_DESERVED_FOR_A_GIFT_START = ' IS_USER_DESERVED_FOR_A_GIFT_START';
export const IS_USER_DESERVED_FOR_A_GIFT_SUCCESS = ' IS_USER_DESERVED_FOR_A_GIFT_SUCCESS';
export const IS_USER_DESERVED_FOR_A_GIFT_FAILED = ' IS_USER_DESERVED_FOR_A_GIFT_FAILED';

export const GET_PRODUCT_BY_ID_START = 'GET_PRODUCT_BY_ID_START';
export const GET_PRODUCT_BY_ID_SUCCESS = 'GET_PRODUCT_BY_ID_SUCCESS';
export const GET_PRODUCT_BY_ID_FAILED = 'GET_PRODUCT_BY_ID_FAILED';

export const GET_ALL_PRODUCTS_START = 'GET_ALL_PRODUCTS_START';
export const GET_ALL_PRODUCTS_SUCCESS = 'GET_ALL_PRODUCTS_SUCCESS';
export const GET_ALL_PRODUCTS_FAILED = 'GET_ALL_PRODUCTS_FAILED';

export const RESERVE_PRODUCT_TO_USER_START = 'RESERVE_PRODUCT_TO_USER_START';
export const RESERVE_PRODUCT_TO_USER_SUCCESS = 'RESERVE_PRODUCT_TO_USER_SUCCESS';
export const RESERVE_PRODUCT_TO_USER_FAILED = 'RESERVE_PRODUCT_TO_USER_FAILED';

export const IS_USER_DESERVED_FOR_THE_PRODUCT_START = 'IS_USER_DESERVED_FOR_THE_PRODUCT_START'
export const IS_USER_DESERVED_FOR_THE_PRODUCT_SUCCESS = 'IS_USER_DESERVED_FOR_THE_PRODUCT_SUCCESS'
export const IS_USER_DESERVED_FOR_THE_PRODUCT_FAILED = 'IS_USER_DESERVED_FOR_THE_PRODUCT_FAILED'